import React from "react";
import moment from "moment";
import { InputDatePicker } from 'mygame-components';
import $ from 'jquery';

const NewMessage = (props) => {
    let { messageConfig, timeData } = props
    let uploadInput

    return (
        <div data-value='mg-createnew-dropdown'
            onClick={(e) => props.clickOutside(e, {})}>
            <div className="mg-messanger-header">
                <span className="mg-messanger-h1">Create Message</span>
                <span className="mg-messanger-h1-close" onClick={props.goBack}><i className="fa fa-arrow-left" aria-hidden="true"></i></span>
            </div>
            <div style={{ border: '1px solid rgba(151,151,151,0.26)', marginTop: '-5.5px' }}></div>
            <div className="mg-messanger-subContent" data-value='mg-createnew-dropdown'>
                <div>Account name</div>
                <input className="mg-messanger-accountList" type="text" onChange={(e) => props.onAccountNameChanges(e)} />
                {/* </div> */}

                <div className="mg-messanger-flex">
                    <div className="mg-messanger-accountListDivider"></div>
                    <div style={{ padding: '0px 63px' }}>or</div>
                    <div className="mg-messanger-accountListDivider"></div>
                </div>
               
                <div className="mg-messanger-dragNDrop">
                { props.fileName && <div style={{color:'black'}}>{props.fileName}</div>}
                    <div
                        className="mg-messanger-dragNDrop-content"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => props.onDropFiles(e)}
                    > 

                        <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                        <input type="file" name="file" data-value='mg-browse-file'
                            className="file_upload"
                            onChange={(e) => props.handleUpload(e)}
                            accept=".csv"
                        />
                        {/* <input type="file" id="file"  onChange={props.handleUpload}  onClick={props.handleUpload}/> */}
                        <span onDragOver={(e) => e.preventDefault()}>&nbsp;Drag and drop </span>
                        <span style={{ color: 'black', fontWeight: '100' }}>&nbsp;or browse files</span>
                    </div>
                </div>
                <div className="mg-messanger-flex mg-message-config-flex" >
                    {
                        messageConfig.map((obj, i) => {
                            return (
                                <div className="mg-messageConfig"
                                    style={{ marginRight: i === 1 ? '0px' : '19.5px' }}>{obj.heading}</div>
                            )
                        })
                    }
                </div>

                <div className="mg-messanger-flex mg-message-config-flex" >
                    {
                        messageConfig.map((obj, i) => {
                            return (
                                <div className="dropdown mg-dropdown mg-messageConfig-box"
                                    data-value={`mg-createMsg-dropdown`}

                                    style={{ marginRight: i === 1 ? '0px' : '19.5px' }}
                                    onClick={(e) => props.openDropDown(e, `${obj.dropBox}DropBox`)}>
                                    <span data-value='mg-createMsg-dropdown'> {obj.selectedConfig}</span>
                                    <span data-value='mg-createMsg-dropdown'>
                                        <i className="fa fa-angle-down mg-down-arrow" data-value='mg-createMsg-dropdown'>

                                        </i>
                                    </span>
                                    {props[`${obj.dropBox}DropBox`] &&
                                        <ul className="mg-options" data-value={`mg-createMsg-dropdown`} style={{ bottom: '-79px' }}>
                                            {obj.configList.map((opt, i) => {
                                                return (
                                                    <li data-value={`mg-createMsg-dropdown`}
                                                        style={{ color: 'black' }}
                                                        onClick={(e) => props.setSelectedValue(e, { ...opt, ...{ dropBox: obj[`dropBox`] } })}>
                                                        {opt.key}
                                                    </li>

                                                )
                                            }
                                            )}
                                        </ul>}
                                </div>

                            )
                        })
                    }
                </div>
                <div className="mg-messanger-flex mg-message-config-flex" >
                    {
                        timeData.map((obj, i) => {
                            return (
                                <div className="mg-messageConfig"


                                    style={{ marginRight: i === 1 ? '0px' : '19.5px' }}>{obj.heading}</div>
                            )
                        })
                    }
                </div>
                <div className="mg-messanger-flex mg-message-config-flex" >
                    {
                        timeData.map((obj, i) => {
                            return (
                                <div className="disabled dropdown mg-dropdown mg-messageConfig-box"
                                    data-value='mg-dropdown'
                                    disabled="disabled"
                                    // data-toggle="modal"
                                    // data-target="#newMessageDatePicker"
                                    style={{ marginRight: i === 1 ? '0px' : '19.5px' }}
                                >
                                    <span data-value='mg-dropdown'> {`${moment(obj.selectedConfig).format("DD.MM.YYYY")} | ${moment(obj.selectedConfig).format("hh:mm")}`}</span><span>
                                        <i className="fa fa-angle-down mg-down-arrow" data-value='mg-dropdown'></i>
                                    </span>
                                </div>)
                        })
                    }
                </div>
                <div className="mg-messageConfig">
                    Message (max 400 characters)
                </div>
                <textarea className="mg-message-text" placeholder="Type message here" onChange={(e) => props.onMessageChange(e)} />

                <center>
                    <div
                        className="mg-mesanger-createNewBtn"
                        style={{ marginBottom: '14.5px' }}
                        onClick={() => props.saveMessageConfiguration(uploadInput)}>
                        SEND
                        </div>
                </center>
            </div>
            <InputDatePicker
                modalId="newMessageDatePicker"
                selectedDate={moment().startOf("day")}
                handleChange={(data) => {
                    //   this.setState({
                    //     tempPartitionDate: moment(data).startOf("day"),
                    //     partitionDateError: "",
                    //   })
                }}
                handleSave={() => {
                    //   this.setState({ partitionDate: this.state.tempPartitionDate })
                    //   if (moment(moment(this.state.tempPartitionDate).format("YYYY-MM-DD HH:mm:ss")).isAfter(moment().startOf("day"))) {
                    //     this.setState({ partitionDateError: "Partition Date must not be in feature" })
                    //   }
                    $('#HandS_partinonDate').click();
                }}
            />
        </div>
    );
};
export default NewMessage;


/** WEBPACK FOOTER **
 ** ./src/components/MyGameMessanger2/NewMessage.js
 **/